import {
  Component,
  forwardRef,
  Input,
  OnChanges,
  SimpleChanges
} from '@angular/core';
import {
  FormArray,
  FormControl,
  FormGroup,
  NG_VALIDATORS,
  NG_VALUE_ACCESSOR
} from '@angular/forms';
import {
  AgpFormUtil,
  CvaFormGroupComponent,
  ResetOptions
} from '@liberty-financial/agp-shared';

import { ContactSummary } from '@features/contacts/models';

@Component({
  selector: 'spark-contacts-trust-trustees',
  templateUrl: './trustees.component.html',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => TrustTrusteesComponent),
      multi: true
    },
    {
      provide: NG_VALIDATORS,
      useExisting: forwardRef(() => TrustTrusteesComponent),
      multi: true
    }
  ]
})
export class TrustTrusteesComponent
  extends CvaFormGroupComponent<string[], { trustee: ContactSummary }[]>
  implements OnChanges
{
  @Input() contacts: ContactSummary[] = [];
  @Input() isRequired = false;

  expandedIndex = -1;
  form = new FormArray<
    FormGroup<{ trustee: FormControl<ContactSummary | null> }>
  >([]);
  formGroup = new FormGroup({
    trustees: this.form
  });

  ngOnChanges(changes: SimpleChanges) {
    if (changes.isRequired) {
      AgpFormUtil.Validators.updateRequiredIfNecessary(this.form, changes.isRequired.currentValue);
    }
  }

  protected reset(opts?: ResetOptions | undefined): void {
    this.form?.reset(undefined, opts);
  }

  protected transformToModel = (
    value: { trustee: ContactSummary }[]
  ): string[] => {
    return value.map((d) => d.trustee?.id);
  };

  protected transformToForm = (v: string[]): { trustee: ContactSummary }[] => {
    const result: { trustee: ContactSummary }[] = [];
    v.forEach((id) => {
      const trustee = this.contacts.find((c) => c.id === id);
      if (trustee) {
        this.add();
        result.push({ trustee });
      }
    });
    return result;
  };

  add(): void {
    this.form.push(
      new FormGroup({
        trustee: new FormControl<ContactSummary | null>(null)
      })
    );
    this.expandedIndex = this.form.length - 1;
  }

  remove(i: number): void {
    this.form.removeAt(i);
  }
}
